module.exports = __webpack_public_path__ + "img/exchanged.2e2daf30.png";